/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { ModalBody, ModalFooter, ModalHeader, ModalNext, Icon, useModal, Loader } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _, { update } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import {
    JobService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';

import metadata from './PolicyDetailsAccordion.metadata.json5';
import styles from './PolicyDetailsAccordion.module.scss'


import { Button, CheckboxField, Radio, RadioField } from '@jutro/legacy/components';


const PolicyDetailsAccordion = props => {
    const {
        policyDetailsData, producerOfServiceValue,
        producerOfRecordValue,
        onTabChangeObj

    } = props;

    const getProducerOfRecordValue = useCallback(()=>{
        if(onTabChangeObj){
            const prodRecordOrg = onTabChangeObj.latestJobPolicyPeriod.producerCodeOfRecordOrg_TFPA
            const prodRecord = onTabChangeObj.latestJobPolicyPeriod.producerCodeOfRecord_TFPA
            return <span>{`${prodRecordOrg} (${prodRecord})`}</span>;
        }

    },[onTabChangeObj])

    const getProducerOfServiceValue = useCallback(()=>{
        if (onTabChangeObj) {
            const prodServiceOrg = onTabChangeObj.latestJobPolicyPeriod.producerCodeOfServiceOrg_TFPA
            const prodService = onTabChangeObj.latestJobPolicyPeriod.producerCodeOfService_TFPA

            return <span>{`${prodServiceOrg} (${prodService})`}</span>;
        }
        
    },[onTabChangeObj])

console.log(onTabChangeObj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {           
            className:styles.fieldStyle
        },
        producerOfRecord: {
            value: getProducerOfRecordValue()
        },
        producerOfService: {
            value: getProducerOfServiceValue()
        },
        // DE16987
        totalAnnualPremiumValueId:{
            visible:_.get(policyDetailsData, 'latestPeriod.jobType_TFPA') === 'PolicyChange'
        }
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={onTabChangeObj}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
};


PolicyDetailsAccordion.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}),
};
export default PolicyDetailsAccordion;
